























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getOutputType } from '@/services/transactions'
import { getTransactionChainType } from '@/js/Transaction'

@Component({
    filters: {
        getOutputType,
    },
})
export default class UtxoTxLinkInput extends Vue {
    @Prop() txID!: string | null
    @Prop() chainID!: string
    @Prop() timestamp!: string

    get URL(): string {
        return `/tx/${this.txID}`
    }

    get chain(): string {
        return getTransactionChainType(this.chainID)?.name || ''
    }
}
